var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulbOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H4M12 3V4M20 12H21M5.6 5.6L6.3 6.3M18.4 5.6L17.7 6.3M11.089 7.083C11.8877 6.93481 12.7105 6.98346 13.4862 7.22475C14.2619 7.46604 14.9671 7.8927 15.5409 8.46782C16.1146 9.04293 16.5396 9.74917 16.779 10.5254C17.0184 11.3017 17.0651 12.1246 16.915 12.923M9.7 17H14.3M3 3L21 21M15.537 15.534C15.3693 15.7019 15.1898 15.8576 15 16C14.6096 16.3865 14.3156 16.8594 14.1419 17.3806C13.9681 17.9018 13.9195 18.4566 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10.0805 18.4566 10.0319 17.9018 9.85813 17.3806C9.6844 16.8594 9.39043 16.3865 9 16C8.42604 15.5697 7.9514 15.0208 7.60832 14.3908C7.26524 13.7608 7.06174 13.0643 7.01166 12.3487C6.96157 11.6331 7.06607 10.915 7.31804 10.2434C7.57002 9.57169 7.96358 8.96211 8.472 8.456L15.537 15.534Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbOff);
export default __webpack_public_path__ + "static/media/BulbOff.4818a2df574cea0c553542bb75e2bd69.svg";
export { ForwardRef as ReactComponent };